//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default{
        name:'bb_form_d',
        data(){
            return{
                coldArr:[],
                form:{
                    room_number:'',
                    baby_name:'',
                    check_in_time:'',
                    body_heat:'',
                    weight:'',
                    boby_length:'',
                    nutritional_status:'',
                    complexion:'',
                    crying:'',
                    reaction:'',
                    skin_case:[],
                    skin_broken_position:'',
                    skin_rash_position:'',
                    feeding_status:'',
                    milk_brand:'',
                    exc_micturition_case:'',
                    exc_micturition_num:'',
                    exc_defecation_case: '',
                    exc_defecation_num:'',
                    exc_diarrhea_num: '',
                    muscle_status:'',
                    muscle_limited_position:'',
                    muscle_lose_position:'',
                    nursing_problem_status:'',
                    nursing_problem:'',
                    questionText:'',
                    feeding_guidance:[],
                    other_desc: '',
                    cold_prevention:'',
                    family_sign:'',
                    nurse_sign:''
                },
                showUserSignature:false,
                showSignature:false,
                option:{
                    penColor:"rgb(0, 0, 0)"
                }
            }
        },
        methods:{
            save(){
                let signature ='signature1'
                console.info(this.$refs[signature])
                let png = this.$refs[signature].save()
                this.form.family_sign = encodeURI(png)
                this.showSignature = true
            },
            edit(){
                this.showSignature = false
                this.form.family_sign = ''
            },
            clear(){
                let signature ='signature1'
                let refs = this.$refs[signature].clear()
                this.form.family_sign = ''
            },
              // 保存客户签名
            saveUserName(){
                let signature ='signature2'
                let png = this.$refs[signature].save()
                this.form.nurse_sign = encodeURI(png)
                this.showUserSignature = true
            },
            //编辑客户签名
            editUserName(){
                this.showUserSignature = false
                this.form.nurse_sign = ''
            },
            //清除客户签名
            clearUserName(){
                let signature ='signature2'
                let refs = this.$refs[signature].clear()
                this.form.nurse_sign = ''
            },
             submitForm(){
                this.form.token=this.$cookie.get('token')
                this.form.number_id=this.$cookie.get('id')
                this.form.maternal_info_id=this.$route.query.id
                this.form.store_id=this.$cookie.get('store_id')
                this.form.baby_id=this.$route.query.child_id
                let params = this.form
                this.form.cold_prevention=this.coldArr.join()
                 console.info(params)
                if(
                    params.room_number==''||params.baby_name==''||params.check_in_time==''||params.weight==''||params.boby_length==''||params.nutritional_status==''||params.complexion==''||params.crying==''||params.reaction==''||
                    params.skin_case.length==0||params.feeding_status==''||params.exc_micturition_case==''||
                    params.exc_micturition_num==''||params.exc_defecation_case==''||params.exc_defecation_num==''||params.muscle_status==''||
                    params.nursing_problem_status==''||params.feeding_guidance.length==0||
                    params.cold_prevention==''
                ){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请完善表单',
                    })
                    return
                }
               
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.otherFormApi.addNewbornFullmoonAssessData(params).then ( res => {
                    this.$vux.loading.hide()
                    console.info(res)
                    if(res.errcode==200){
                        this.$router.replace({
                            path:'/success',
                            query:{
                                id:this.$route.query.id,
                                tabVal: this.$route.query.tabVal,
                                form_id:res.data.id,
                                name : 'bb_form_d',
                            }
                        })
                    }
                })
            },
            apiMemberInfo(){
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id: this.$route.query.id
                }
                Api.checkRoomApi.memberInfo(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 1){
                        this.form.mom_name = res.data.name
                        this.form.room_number = res.data.room_name
                        this.form.check_in_time = this.formatDateTime(res.data.live_time)
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            //时间戳转日期格式    
            formatDateTime(inputTime) {  
                var date = new Date(parseInt(inputTime)*1000)
                var y = date.getFullYear() 
                var m = date.getMonth() + 1  
                m = m < 10 ? ('0' + m) : m; 
                var d = date.getDate()
                d = d < 10 ? ('0' + d) : d
                var h = date.getHours()
                h = h < 10 ? ('0' + h) : h
                var minute = date.getMinutes()
                var second = date.getSeconds()
                minute = minute < 10 ? ('0' + minute) : minute 
                second = second < 10 ? ('0' + second) : second
                return y + '-' + m + '-' + d
            },
            get_baby_list (){
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id: this.$route.query.id
                }
                Api.monthLiveApi.babyList(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 1){
                        this.baby_list = res.data
                        let get_boby_id = this.$route.query.child_id
                        for(let item of res.data){
                            if(item.id == get_boby_id){
                                // this.form.bobyLength = item.weight
                                this.form.baby_name=item.name
                            }
                        }
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            goBack(){
                this.$router.push({
                    path: './maternal_service',
                    query: {
                        tabVal: this.$route.query.tabVal,
                        id: this.$route.query.id
                    }
                })
            }
        },
        created(){
            this.apiMemberInfo()
            this.get_baby_list()
            // this.form.baby_name=this.$route.query.baby_name
            // this.form.sex=this.$route.query.baby_sex
        }
    }



// WEBPACK FOOTER //
// ./src/components/bb_form_d.vue